import { useStore } from '@slope/store';
import { isMesh } from '@slope/three';
import * as THREE from 'three';

export interface Obstacle {
  id: string;
  type: 'bunker' | 'lake' | 'river';
  mesh: THREE.Mesh;
}

/**
 * Hook to get all obstacles in the scene.
 * It traverses the scene graph and collects objects that match the obstacle naming convention.
 */
export const useObstacles = (): Obstacle[] => {
  const { scene } = useStore();
  let obstacles: Obstacle[] = [];

  scene.traverseVisible((child) => {
    const match = isMesh(child) && /(bunker|lake|river)/.exec(child.name);

    if (match) {
      obstacles.push({
        id: child.uuid,
        type: match[0] as 'bunker' | 'lake' | 'river',
        mesh: child,
      });
    }
  });

  return obstacles;
};
